import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/material/styles';
import FieldTypes from 'modules/connect-card/constants/field-types';
import React from 'react';
import Address from './Address';
import Choice from './Choice';
import DateInput from './DateInput';
import Email from './Email';
import AddMember from './Guests';
import Name from './Name';
import NumberInput from './NumberInput';
import Phone from './Phone';
import RadioGroup from './RadioGroup';
import Rating from './Rating';
import Scheduler from './Scheduler';
import Survey from './Survey';
import TextField from './TextField';

const BooleanOptions = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

export const QuestionField = ({ field, placeholder, autoFocus, account }) => {
  const {
    id,
    hash,
    question_type,
    question_required,
    question_possible_answers,
    question_settings,
  } = field;

  const isRequired = question_required === '1';

  const props = {
    id: hash,
    placeholder,
    required: isRequired,
    inputProps: {
      autoFocus,
    },
    settings: {},
    account,
  };

  if (question_settings) {
    if (typeof question_settings === 'string') {
      try {
        props.settings = JSON.parse(question_settings);
      } catch (e) {
        props.settings = {};
      }
    } else {
      props.settings = question_settings;
    }
  }

  const choiceOptions = Array.isArray(question_possible_answers)
    ? question_possible_answers.map((answer) => ({
        label: answer.value,
        value: answer.id,
      }))
    : [];

  switch (question_type) {
    case FieldTypes.TEXT: {
      return <TextField {...props} />;
    }
    case FieldTypes.PARAGRAPH:
      return <TextField multiline rows={3} {...props} />;
    case FieldTypes.EMAIL: {
      return <Email {...props} />;
    }
    case FieldTypes.PHONE: {
      return <Phone {...props} />;
    }
    case FieldTypes.CHOICE: {
      return <Choice options={choiceOptions} {...props} />;
    }
    case FieldTypes.BOOLEAN: {
      return <RadioGroup options={BooleanOptions} {...props} />;
    }
    case FieldTypes.DATE: {
      return <DateInput {...props} />;
    }
    case FieldTypes.NUMBER: {
      return <NumberInput {...props} />;
    }
    case FieldTypes.NAME: {
      return <Name {...props} />;
    }
    case FieldTypes.ADDRESS: {
      return <Address {...props} />;
    }
    case FieldTypes.SURVEY: {
      return <Survey {...props} />;
    }
    case FieldTypes.RATING: {
      return <Rating {...props} />;
    }
    case FieldTypes.SCHEDULER: {
      const options = question_possible_answers;
      return <Scheduler options={options} {...props} />;
    }
    case FieldTypes.ADD_MEMBERS: {
      return <AddMember {...props} />;
    }
    default:
      return 'unknown question ' + question_type;
  }
};

const Field = ({ field, isLast, onNext, autoFocus, account }) => {
  const { question_label, question_placeholder, question_name } = field;

  return (
    <Paper
      elevation={0}
      sx={{
        px: 2,
        py: 1,
        borderRadius: 2,
        bgcolor: 'rgba(255,255,255,.5)',
      }}
    >
      <Typography gutterBottom fontWeight={500}>
        {question_label}
      </Typography>
      <QuestionField autoFocus={autoFocus} field={field} account={account} />
    </Paper>
  );
};

export default Field;
